module.exports = __webpack_public_path__ + "static/media/pen.06a3f2c5.svg";